export default __webpack_public_path__ + "static/media/Love02.df2b64e0.png";